<template>
  <div class="layout-container">
    <core-sidebar v-if="ninja" :isCollapsed="isCollapsed" @toggleCoreSidebar="toggleCoreSidebar"
      @openCoreSidebar="openCoreSidebar" />

    <div class="main-content">
      <core-navbar v-if="ninja" class="navbar" @toggleCoreSidebar="toggleCoreSidebar" />

      <main slot="content" id="content" class="content" role="main">
        <vuestic-pre-loader v-show="isLoading" class="pre-loader"></vuestic-pre-loader>
        <router-view v-on:onPresenca="onPresenca" v-on:onEAD="onEAD"></router-view>
      </main>

      <span class="footer">© {{ getDateYearActual() }} - FábricaInfo</span>
    </div>
  </div>
</template>

<script>
import Layout from "vuestic-theme/vuestic-directives/Layout";
import { mapGetters } from "vuex";
import router from "../../router/index";
import CoreSidebar from '../core/sidebar';
import CoreNavbar from '../core/navbar';

export default {
  name: "app-layout-comercial",
  components: {
    CoreSidebar,
    CoreNavbar
  },
  directives: {
    layout: Layout,
  },
  data() {
    return {
      isCollapsed: false,
      opened: true,
      ninja: true,
    };
  },
  mounted() {
    if (localStorage.id_role == "6") {
      router.push({ name: "faturas_boletos" });
    }
  },
  methods: {
    toggleCoreSidebar() {
      this.isCollapsed = !this.isCollapsed;
    },
    openCoreSidebar() {
      this.isCollapsed = false
    },
    showFaturasBoletos() {
      this.$router.push({
        name: "faturas_boletos",
        params: {
          activeItem: "faturas_boletos",
        },
      });
    },
    toggleSidebar(opened) {
      this.opened = opened;
    },

    getDateYearActual() {
      let dt = new Date();
      return dt.getFullYear();
    },

    onPresenca(value) {
      this.$data.ninja = value;
    },

    onEAD(value) {
      this.$data.ninja = value;
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
  display: flex;
  overflow-x: hidden;
}

.main-content {
  flex: 1;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
  }

  .footer {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: 600;
  }
}
</style>
